import { RequestGoogleNearbySearchPayload } from "../types";

export const REQUEST_GOOGLE_NEAR_BY_SEARCH = "REQUEST_GOOGLE_NEAR_BY_SEARCH" as const;
export const REQUEST_GOOGLE_NEAR_BY_SEARCH_SUCCESS = "REQUEST_GOOGLE_NEAR_BY_SEARCH_SUCCESS" as const;
export const NO_TOW_LOCATIONS_FOUND = "NO_TOW_LOCATIONS_FOUND" as const;
export const ERROR_GETTING_NEAR_BY_DESTINATIONS = "ERROR_GETTING_NEAR_BY_DESTINATIONS" as const;
export const ERROR_ADDING_NEW_NEAR_BY_DESTINATIONS = "ERROR_ADDING_NEW_NEAR_BY_DESTINATIONS" as const;
export const REQUEST_GOOGLE_MORE_DETAILS_NEAR_BY_SEARCH = "REQUEST_GOOGLE_MORE_DETAILS_NEAR_BY_SEARCH" as const;

export const requestGoogleNearbySearch = (payload: RequestGoogleNearbySearchPayload) =>
  ({ type: REQUEST_GOOGLE_NEAR_BY_SEARCH, payload } as const);

export const requestAdditionalNearByDestinationsForDropdown = (payload) =>
  ({
    type: REQUEST_GOOGLE_MORE_DETAILS_NEAR_BY_SEARCH,
    payload,
  } as const);
